import { render, staticRenderFns } from "./alarmTimeBox.vue?vue&type=template&id=71006b6c&scoped=true"
import script from "./alarmTimeBox.vue?vue&type=script&lang=js"
export * from "./alarmTimeBox.vue?vue&type=script&lang=js"
import style0 from "./alarmTimeBox.vue?vue&type=style&index=0&id=71006b6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71006b6c",
  null
  
)

export default component.exports